const DocumentHeaderBG = ({
  className,
  height = '121',
  width = '164',
  color = '#F2F4F7',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
    >
      <path
        d="M0 110V11C0 4.92487 4.92487 0 11 0H124.415C127.53 0 130.498 1.32039 132.584 3.63345L161.169 35.3325C162.991 37.3533 164 39.9779 164 42.699V110C164 116.075 159.075 121 153 121H11C4.92487 121 0 116.075 0 110Z"
        fill={color}
      />
    </svg>
  )
}

export default DocumentHeaderBG
